import { getStore } from 'owa-mail-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
export function shouldSkipEmailAddress(emailAddress) {
    var shouldSkip = false;
    if (isConsumer()) {
        var userConfig = getUserConfiguration();
        emailAddress = emailAddress.toLowerCase();
        shouldSkip =
            emailAddress.indexOf('outlook_' + userConfig.HexCID) == 0 ||
                emailAddress.indexOf('@shadow.outlook.com') != -1;
    }
    return shouldSkip;
}
export function getAliasAddresses(primaryAddress) {
    var sessionSettings = getUserConfiguration().SessionSettings;
    var aliasAddress = [];
    var addresses = sessionSettings.UserProxyAddresses;
    if (sessionSettings.NotManagedEmailAddresses) {
        addresses = addresses.concat(sessionSettings.NotManagedEmailAddresses);
    }
    if (addresses && addresses.length > 0) {
        addresses.forEach(function (address) {
            if (primaryAddress != address && !shouldSkipEmailAddress(address)) {
                aliasAddress.push(address);
            }
        });
    }
    return aliasAddress;
}
export function getConnectedAccounts(currentList) {
    var connectedAccountInfos = getUserConfiguration().SessionSettings.ConnectedAccountInfos;
    if (connectedAccountInfos && connectedAccountInfos.length > 0) {
        connectedAccountInfos.forEach(function (connectedAccount) {
            if (currentList.lastIndexOf(connectedAccount.EmailAddress) == -1) {
                currentList.push(connectedAccount.EmailAddress);
            }
        });
    }
    return currentList;
}
// TODO: Parse through SharingInstanceGuid to determine what connected account info to use (VSO:29460)
export function getAlternativeFromAddress(fromAddress) {
    var sessionSettings = getUserConfiguration().SessionSettings;
    var primaryAddress = sessionSettings.UserEmailAddress;
    if (primaryAddress == fromAddress && shouldSkipEmailAddress(fromAddress)) {
        var aliases = getAliasAddresses(primaryAddress);
        if (aliases && aliases.length > 0) {
            return aliases[0];
        }
    }
    return fromAddress;
}
function isInRecipients(emailAddress, recipients) {
    if (recipients) {
        for (var i = 0; i < recipients.length; i++) {
            if (emailAddress == recipients[i].EmailAddress) {
                return true;
            }
        }
    }
    return false;
}
function tryFindRecipient(message, addresses) {
    for (var i = 0; i < addresses.length; i++) {
        if (isInRecipients(addresses[i], message.ToRecipients) ||
            isInRecipients(addresses[i], message.CcRecipients)) {
            return addresses[i];
        }
    }
    return null;
}
export function getDefaultFromAddress(referenceItemId) {
    var sessionSettings = getUserConfiguration().SessionSettings;
    var primaryAddress = sessionSettings.UserEmailAddress;
    var mailStore = getStore();
    var items = mailStore && mailStore.items;
    var referenceItem;
    if (items && referenceItemId && items.has(referenceItemId.Id)) {
        referenceItem = items.get(referenceItemId.Id);
    }
    if (referenceItem) {
        if (isInRecipients(primaryAddress, referenceItem.ToRecipients) ||
            isInRecipients(primaryAddress, referenceItem.CcRecipients)) {
            return null;
        }
        // TODO: Check SharingInstanceGuid here. (VSO:29460)
        if (isConsumer()) {
            var aliasAddresses = getAliasAddresses('');
            var allAddresses = getConnectedAccounts(aliasAddresses);
            if (allAddresses) {
                return tryFindRecipient(referenceItem, allAddresses);
            }
        }
    }
    return null;
}
//# sourceMappingURL=getFromAddresses.js.map